$(document).on('init:photomanipulator.nearme', function(event, el) {
  require.ensure('../modules/photo_manipulator', function(require) {
    var PhotoManipulator = require('../modules/photo_manipulator');
    new PhotoManipulator(el);
  });
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/photo_manipulator.initializer.js